<template>
  <div>
    <van-popup
      v-model="isShow"
      class="sub-popup"
      get-container="body"
      :close-on-click-overlay="false"
    >
      <img
        class="icon_close"
        src="@/assets/img/activity/icon_close.png"
        alt=""
        @click="closePop()"
      />
      <div class="success">关注成功</div>
      <div class="act_info">
        {{ pageConfig.activityZoneTitle }} ·
        {{ commonStore.intention.expectFunctionString }} ·
        {{ areaName }}
      </div>
      <!-- 未开启微信通知 -->
      <div v-if="!commonStore.wechatFollow" class="open_notice">
        <div>
          开启微信通知，“<span class="activity_name">{{
            pageConfig.activityZoneTitle
          }}</span
          >”
        </div>
        <div>最新职位通知第一时间为你送达！</div>
        <img class="sub_tips" src="@/assets/img/activity/wxtz.png" alt=/>
        <div class="sub_btn" :class="giftFlag ? 'sub_btn_box' : ''" @click="openWechat">
          立即开启
          <div v-show="giftFlag" class="sub_btn_box_bubble">
            <span>
              {{`赠${giftType == '1' ? 3 : 5}天“`}}
            </span>
            <span class="sub_btn_box_bubble_text">
              {{ giftType == '1' ? '谁对我感兴趣' : '简历刷新' }}
            </span>
            <span>
              ”服务
            </span>
          </div>
        </div>
      </div>
      <!-- 未开启消息通知 -->
      <div v-else-if="!appMessageState" class="open_notice">
        <div>
          开启消息通知，“<span class="activity_name">{{
            pageConfig.activityZoneTitle
          }}</span
          >”
        </div>
        <div>最新职位通知第一时间为你送达！</div>
        <img class="sub_tips" src="@/assets/img/activity/xxtz.png" alt=/>
        <div class="sub_btn" @click="openMessage">立即开启</div>
      </div>
      <!-- 已开启微信通知&&开启push通知 -->
      <template v-else>
        <div class="success_tip">职位有更新及时通知你</div>
        <div class="sub_btn" @click="closePop()">我知道了</div>
      </template>

      <div class="follow_tip">App-我的-关注与订阅中可以取消关注</div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import wx from "weixin-js-sdk";
import { Popup } from "vant";
export default {
  name: "FollowPop",
  components: {
    [Popup.name]: Popup,
  },
  props: {
    followPopVisible: {
      type: Boolean,
      default: false,
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
    giftFlag:{//是否显示赠送气泡
      type: Boolean,
      default: false,
    },
    giftType:{//奖励类型 1：谁对我感兴趣  2：简历刷新五次
      type:String,
      default:'1'
    }
  },
  data() {
    return {
      appMessageState: false,
      isShow: false,
      // giftFlag:false, //是否显示赠送气泡
      // giftType:'1' //奖励类型 1：谁对我感兴趣  2：简历刷新五次
    };
  },
  watch: {
    followPopVisible(status) {
      this.isShow = status;
      console.log(
        status,
        this.followPopVisible,
        this.commonStore,
        this.appMessageState,
        "this.followPopVisible111"
      );
    },
  },
  computed: {
    ...mapState(["commonStore"]),
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isApp() {
      return (
        this.$store.getters.platform === "51jobApp" ||
        this.$store.getters.platform === "yjsApp"
      );
    },
    isWeChat() {
      return this.$store.getters.appType === "weixin";
    },
    platform() {
      return this.$store.getters.platform;
    },
    isMiniProgram() {
      return (
        this.$store.getters.platform === "51jobWX" ||
        this.$store.getters.platform === "yjsWX"
      );
    },
    areaName() {
      return this.$store.getters.areaName;
    }
  },
  created() {
    console.log(this.commonStore.intention, "pageConfig.activityZoneTitle");
    this.appMessageSwitch();
    // this.getCheckGiftCondition()//赠送谁对我感兴趣条件检查
  },
  methods: {
  //  async getCheckGiftCondition(){
  //     const res = await this.$api.activity.checkGiftCondition({checkRange: '2,3,4'})
  //     if(res.status == "1"){
  //       this.giftFlag = res.resultbody.giftFlag;
  //       this.giftType = res.resultbody.giftType;
  //     }
  //   },
    // 是否开启消息通知
    appMessageSwitch() {
      console.log("是否开启消息通知");
      // 回调
      window.appMessage = (res) => {
        this.appMessageState = res.phoneSystemSwitch;
      };
      if (this.commonStore.device == "androidApp") {
        this.appMessageState = window.android.jsAppBridgeGetPhoneSystemSwitch();
      }
      if (this.commonStore.device == "iosApp") {
        window.webkit.messageHandlers.model.postMessage([
          "jsAppBridgeGetPhoneSystemSwitch:",
          { callback: "appMessage" },
        ]);
      }
      console.log(this.appMessageState, "this.appMessageState");
    },
    openMessage() {
      this.$base.watchAppCover(this.appMessageSwitch);
      this.closePop();
      if (this.platform.includes("yjs")) {
        window.location.href =
          "yingjiesheng://home/openMessageAndSystemSettingPage";
        // this.$base.openMessageAndSystemSettingPage();
      } else {
        if (this.commonStore.device == "harmonyApp") {
          window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
            url: "qiancheng://home/show_message_setting_page"
          }));
        } else {
          window.location = "qiancheng://home/show_message_setting_page";
        }
      }
    },
    closePop() {
      this.$emit("update:followPopVisible", false);
    },
    openWechat() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_top_follow",
      });
      this.$router.push({ path: "/scanCode" });
    },
    openAppWechat() {
      if (this.platform == "yjsApp") {
        window.location.href =
          "yingjiesheng://home/openMessageAndSystemSettingPage";
      } else if (this.commonStore.device == "harmonyApp") {
        window.harmony.jsAppBridgeOpenScheme(JSON.stringify({
          url: "qiancheng://home/show_system_settings"
        }));
      } else {
        window.location.href = "qiancheng://home/show_system_settings";
      }

      this.closePop();
    },
  },
};
</script>

<style lang="less" scoped>
.sub-popup {
  position: fixed;
  overflow-y: visible;
  width: 311px;
  background: linear-gradient(180deg, #fffce1 0%, #ffffff 50%);
  border-radius: 16px;
  text-align: center;
  font-style: normal;
  padding-top: 32px;
  .icon_close {
    position: absolute;
    top: 10px;
    left: 16px;
    width: 18px;
    height: 18px;
  }
  .success {
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    color: #000000;
  }
  .act_info {
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    color: #ff6c0e;
    max-width: 268px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 4px auto 0;
  }
  .open_notice {
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    color: #000000;
    margin-top: 16px;
    .activity_name {
      max-width: 130px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .success_tip {
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    color: #666666;
    margin: 6px 0 16px;
  }
  .sub_tips {
    width: 100%;
    height: 148px;
    margin: 18px 0 -35px;
  }
  .sub_btn {
    width: 200px;
    height: 44px;
    line-height: 44px;
    margin: 0 auto;
    border-radius: 22px;
    opacity: 1;
    background: linear-gradient(180deg, #ffb240 2%, #ff6300 100%);
    box-sizing: border-box;
    border: 1px solid #ffe7ce;
    box-shadow: inset 0px 3px 9px 0px #ff6906;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
  }
  .sub_btn_box{
    position: relative;
    margin-top: 13px;
    .sub_btn_box_bubble{
      padding: 0 8px;
      box-sizing: border-box;
      position: absolute;
      top: -14px;
      right: -20px;
      // width: 158px;
      max-width: 199px;
      height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 600;
      /* 赠3天“ */
      color: #983400;
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
      border-bottom-right-radius: 14px;
      background: linear-gradient(270deg, #FFF69D 2%, #FFEC59 100%);
      .sub_btn_box_bubble_text{
        color: #FF6C0E;
      }
    }
  }
  .follow_tip {
    font-size: 10px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    color: #999999;
    margin: 14px 0 12px;
  }
}
</style>
